var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex items-start justify-center md:mt-24 pb-64"},[_c('login-form-component',{staticClass:"mt-10"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }